<template>
  <div
    :class="{
      'image-loaded': isImageLoaded,
      'image-broken': isImageBroken,
    }"
    data-component-name="AppAvatar"
  >
    <NuxtImg
      v-if="canLoadImage"
      :src
      :alt
      densities="x1 x2"
      format="webp"
      loading="lazy"
      @load="successHandler"
      @error="errorHandler"
    />

    <span v-if="initials">
      {{ initials }}
    </span>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    size?: string;

    src?: string;
    alt: string;

    initials?: string;
  }>(),
  {
    size: '3.5rem',
  },
);

const id = useId();

const COLORS = [
  '#662E9C',
  '#9C2E84',
  '#08882E',
  '#0050B3',
  '#931200',
  '#C54700',
];
const accent = useState(
  `${id}-accent`,
  () => COLORS[Math.floor(Math.random() * COLORS.length)],
);

const canLoadImage = ref(true);
const isImageLoaded = ref(false);
const isImageBroken = ref(false);

const successHandler = () => {
  isImageLoaded.value = true;
  isImageBroken.value = false;
};
const errorHandler = () => {
  isImageBroken.value = true;
};

watch(
  () => props.src,
  src => {
    canLoadImage.value = typeof src === 'string';
  },
  {
    immediate: true,
  },
);
</script>

<style scoped lang="scss">
@import '$/mixins/flex';
@import '$/mixins/size';
@import '$/mixins/typography';
@import '$/mixins/position';
@import '$/variables/fonts';
@import '$/functions/token';

[data-component-name='AppAvatar'] {
  @include fixed-size(v-bind(size));
  border: 1px solid token('outline-secondary');
  border-radius: 100%;
  @include flex-center-center;
  position: relative;
  overflow: hidden;

  background-color: v-bind(accent);
  transition: all 0.15s ease;

  img {
    @include absolute-center;
    width: 100%;
    height: auto;
    object-fit: cover;

    opacity: 0;
    transition: opacity 0.15s ease;
  }

  span {
    color: token('text-reversed');
    @include subtitle-2;
  }

  &.image-loaded {
    background-color: transparent;

    img {
      opacity: 1;
    }

    span {
    }
  }

  &.image-broken {
    img {
    }

    span {
    }

    &:not(:has(span)) {
      background-color: transparent;
      border-color: transparent;
    }
  }
}
</style>
